import React from 'react';
import { MenuItem } from 'primereact/menuitem';

interface UrgencyOption {
  name: string;
  code: string;
  avatar: string;
}

interface UrgencyMenuProps {
  options: UrgencyOption[];
  selectedOptions: UrgencyOption[];
  onSelect: (option: UrgencyOption, e: React.MouseEvent | React.KeyboardEvent) => void;
}

const UrgencyMenu = ({
  options,
  selectedOptions,
  onSelect,
}: UrgencyMenuProps): MenuItem[] => {
  return options.map((option) => ({
    template: () => (
      <button
        className={`urgency-menu-item flex align-items-center ${
          selectedOptions.some((o) => o.code === option.code) ? 'selected' : ''
        }`}
        tabIndex={0}
        onClick={(e) => onSelect(option, e)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect(option, e);
          }
        }}
      >
        <span className={`avatar ${option.avatar}`} />
        <span className="option-label ml-1">{option.name}</span>
      </button>
    ),
  }));
};
export default UrgencyMenu;
